import { GET_CONSUMPTION } from '../actions/chargingStation';

const initialState = {
  isLoading: false,
  consumptions: [],
};

const consumptionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_CONSUMPTION.REQUEST: {
      return { ...state, isLoading: true };
    }
    case GET_CONSUMPTION.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        consumptions: payload,
      };
    }

    case GET_CONSUMPTION.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};
export default consumptionReducer;
